import JsBarcode from 'jsbarcode'

import { ITableColumn } from '@makyoapp/makyo-sdk/models/Table'
import { BarcodeType } from '@makyoapp/makyo-common'

import { Cell, ICell } from '.'

export interface IBarcodeSettings {
  barcodeColumn: string
  barcodeType: BarcodeType
}

export interface IBarcode extends ITableColumn {
  Settings: IBarcodeSettings
}

export interface IBarcodeCell extends ICell {
  settings: IBarcodeSettings
  barcodeOptions: Record<string, unknown>
  dataURL: string
}

export class BarcodeCell implements IBarcodeCell {
  value: Cell
  settings: IBarcodeSettings
  barcodeOptions: Record<string, unknown>
  dataURL: string

  // note: the barcode cell will initialize its value from settings
  constructor(value: null, settings: IBarcodeSettings) {
    this.value = settings.barcodeColumn ?? '' // assume that the value of settings already parsed
    this.settings = {
      barcodeColumn: settings.barcodeColumn,
      barcodeType: settings.barcodeType,
    }
    this.barcodeOptions = getBarcodeProps(settings.barcodeType)
    this.dataURL = generateBarcodeURL(this.value as string, this.barcodeOptions)
  }

  toString(): string {
    return this.dataURL
  }

  toCell<T extends Cell>(value: T) {
    this.value = value !== undefined && value !== null ? value : ''
    return this
  }

  get cellBarcodeOptions(): Record<string, unknown> {
    return this.barcodeOptions
  }
}

export function generateBarcodeURL(value: string, barcodeOptions: Record<string, unknown>) {
  const xmlSerializer = new XMLSerializer()
  const svgNode = document.createElementNS('http://www.w3.org/2000/svg', 'svg')

  if (!!value && value.toString().trim() !== '') {
    try {
      JsBarcode(svgNode, value as string, {
        ...barcodeOptions,
        displayValue: true,
        width: 10,
        margin: 5,
      })
    } catch (err) {
      console.error('[CustomBarcodeRenderer] error: ', { err })
    }
  }

  const svg = xmlSerializer.serializeToString(svgNode)
  const byte = window.btoa(svg)
  const dataURL = `data:image/svg+xml;base64,${byte}`

  return dataURL
}

function getBarcodeProps(barcodeType: BarcodeType) {
  const barcodeProps: Record<string, unknown> = {
    format: '',
  }

  switch (barcodeType) {
    case BarcodeType.UPC:
      barcodeProps.format = 'UPC'
      break
    case BarcodeType.CODE128:
      barcodeProps.format = 'CODE128'
      break
    case BarcodeType.CODE39:
      barcodeProps.format = 'CODE128'
      break
    case BarcodeType.EAN13:
      barcodeProps.format = 'EAN13'
      break
    case BarcodeType.EAN8:
      barcodeProps.format = 'EAN8'
      break
    case BarcodeType.EAN128:
      barcodeProps.format = 'CODE128C'
      barcodeProps.ean128 = true
      break
  }

  return barcodeProps
}
